import { render } from "./PageNotFound.vue?vue&type=template&id=2c39b186"
const script = {}

import exportComponent from "/var/www/nicedate.elena-dating.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__